<!-- @format -->
<script lang="ts">
  import { getStoresContext } from "~/stores";
  import type { StoresKey } from "~/stores";

  export let item: NavigationMenuItem;
  export let request_store_key: StoresKey;
  const { site_page, reverse_router, i18nOf, locale } =
    getStoresContext(request_store_key);

  $: current = $site_page?.friendlyUrlPath;
  const name = i18nOf(item.name_i18n);
</script>

{#if item.type == "url"}
  {#if item.availableLanguages.includes($locale)}
    <li
      class="nav-item"
      class:active={item.link == current}
      title={i18nOf(item.name_i18n)}>
      <a
        style="color: inherit; text-decoration: inherit;"
        href={item.url}
        target="_blank"
        class="d-block py-2">
        {name}
      </a>
    </li>
  {/if}
{:else}
  <li
    class="nav-item"
    class:active={item.link == current}
    title={i18nOf(item.name_i18n)}>
    <a
      style="color: inherit; text-decoration: inherit;"
      class="d-block py-2"
      href={$reverse_router.routePage(item.link)}>
      {name}
    </a>
  </li>
{/if}

<style lang="scss">
  .nav-item {
    list-style: none;
    margin: 0 48px 0 0;
    font-style: normal;
    font-size: 20px;
    &:hover {
      font-weight: 500;
      border-bottom: 2px solid var(--color-black);
    }
    position: relative;
    height: 52px;
  }
  .active {
    font-weight: 500;
    border-bottom: 2px solid var(--brandColor3);
  }

  .nav-item::after {
    content: attr(title);
    font-weight: 500;
    visibility: hidden;
    height: 0;
    display: block;
  }
</style>
